/**
 * Build-time version information
 * These values are injected by Vite at build time via `define` in vite.config.ts
 * - __APP_VERSION__: from package.json version
 * - __BUILD_NUMBER__: short git commit hash
 * - __BUILD_DATE__: ISO timestamp of when the build was created
 */

declare const __APP_VERSION__: string;
declare const __BUILD_NUMBER__: string;
declare const __BUILD_DATE__: string;

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';
export const BUILD_NUMBER = typeof __BUILD_NUMBER__ !== 'undefined' ? __BUILD_NUMBER__ : 'dev';
export const BUILD_DATE = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : new Date().toISOString();

/**
 * Format the build date to a readable Thai-friendly format
 * e.g. "27/02/2026 14:30"
 */
export function getFormattedBuildDate(): string {
  try {
    const date = new Date(BUILD_DATE);
    return date.toLocaleString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return BUILD_DATE;
  }
}

/**
 * Get full version string e.g. "v1.3.0 (abc1234)"
 */
export function getFullVersionString(): string {
  return `v${APP_VERSION} (${BUILD_NUMBER})`;
}
